import script from "./TopNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNav.vue?vue&type=script&setup=true&lang=ts"

import "./TopNav.vue?vue&type=style&index=0&id=52dc4a9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@5.6.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52dc4a9d"]])

export default __exports__